export type { L2PillsListProps } from './L2PillsList';
export { L2PillsList } from './L2PillsList';
